import { useTranslation } from 'react-i18next';
import { Globe, Building2, Network, Lock } from 'lucide-react';
import type { ShareVisibility } from '../types/video';

const ICONS: Record<ShareVisibility, typeof Globe> = { public: Globe, org: Building2, network: Network, private: Lock };

/** Who can open a share link: the four choices, translated, in display order. */
export const useShareVisibilityOptions = (iconSize = 15) => {
  const { t } = useTranslation();
  return (Object.keys(ICONS) as ShareVisibility[]).map((value) => {
    const Icon = ICONS[value];
    return {
      value,
      icon: <Icon size={iconSize} aria-hidden />,
      label: t(`share_visibility.${value}`),
      desc: t(`share_visibility.${value}_desc`),
    };
  });
};
